import { type AriaRole, type FocusEvent, forwardRef, useId } from "react"

import { SearchInput } from "../SearchInput"
import { FormInputField, type FormInputFieldProps } from "./FormField"

export interface FormSearchInputProps
  extends Pick<
    FormInputFieldProps,
    "disabled" | "error" | "sx" | "description" | "roundedSide"
  > {
  label?: string
  placeholder?: string
  maxLength?: number
  isLoading?: boolean
  value: string
  onValueChange: (value: string) => void
  role?: AriaRole
  onFocus?: (event: FocusEvent<HTMLInputElement, Element>) => void
  onBlur?: (event: FocusEvent<HTMLInputElement, Element>) => void
  startAdornment?: boolean
  endAdornment?: boolean
  autoFocus?: boolean
}

export const FormSearchInput = forwardRef<
  HTMLInputElement,
  FormSearchInputProps
>(function FormSearchInput(props: FormSearchInputProps, ref) {
  const {
    label,
    sx,
    disabled = false,
    error,
    description,
    roundedSide,
    ...otherProps
  } = props

  const id = useId()

  return (
    <FormInputField
      id={id}
      label={label}
      sx={sx}
      disabled={disabled}
      error={error}
      description={description}
      roundedSide={roundedSide}
    >
      <SearchInput
        id={id}
        ref={ref}
        {...otherProps}
        sx={{ alignSelf: "stretch" }}
        disabled={disabled}
      />
    </FormInputField>
  )
})
